export enum AppBarTitleType {
  BROADCAST_HEADER = "BROADCAST_HEADER",
  BROADCAST_SIMPLE_HEADER = "BROADCAST_SIMPLE_HEADER",
  SPACER = "SPACER",
}
